export type WorkspaceView =
  | "onboarding"
  | "dashboard"
  | "campaigns"
  | "campaign-detail"
  | "campaign-editor"
  | "funnels"
  | "tracking"
  | "contacts"
  | "contact-list-detail"
  | "contact-detail"
  | "inbox"
  | "settings"
  | "connections"
  | "voices"
  | "admin"
  | "admin-users"
  | "admin-plans"
  | "admin-usage"
  | "admin-analytics"
  | "admin-settings";

export type WorkspaceNavItem = {
  id: WorkspaceView;
  label: string;
};

export const workspaceViewTitles: Record<WorkspaceView, string> = {
  onboarding: "Account onboarding",
  dashboard: "Dashboard",
  campaigns: "Campaigns",
  "campaign-detail": "Campaign details",
  "campaign-editor": "Campaign editor",
  funnels: "Funnel Builder",
  tracking: "Tracking",
  contacts: "Contacts",
  "contact-list-detail": "Contact list",
  "contact-detail": "Contact details",
  inbox: "Inbox",
  settings: "Account settings",
  connections: "Connections",
  voices: "Voices",
  admin: "Admin overview",
  "admin-users": "Users",
  "admin-plans": "Plans",
  "admin-usage": "Usage and costs",
  "admin-analytics": "Analytics",
  "admin-settings": "Platform settings",
};

export const completedWorkspaceNav: WorkspaceNavItem[] = [
  { id: "dashboard", label: "Dashboard" },
  { id: "campaigns", label: "Campaigns" },
  { id: "funnels", label: "Funnel Builder" },
  { id: "tracking", label: "Tracking" },
  { id: "contacts", label: "Contacts" },
  { id: "inbox", label: "Inbox" },
  { id: "settings", label: "Settings" },
  { id: "connections", label: "Connections" },
  { id: "voices", label: "Voices" },
];

export const platformAdminWorkspaceNav: WorkspaceNavItem[] = [
  { id: "admin", label: "Overview" },
  { id: "connections", label: "Connections" },
  { id: "tracking", label: "Tracking domains" },
  { id: "campaigns", label: "Campaigns" },
  { id: "admin-users", label: "Users" },
  { id: "admin-plans", label: "Plans" },
  { id: "admin-usage", label: "Usage" },
  { id: "admin-analytics", label: "Analytics" },
  { id: "admin-settings", label: "Settings" },
];

export const adminWorkspaceNav: WorkspaceNavItem = { id: "admin", label: "Admin" };

export const onboardingWorkspaceNav: WorkspaceNavItem[] = [
  { id: "onboarding", label: "Onboarding" },
  { id: "settings", label: "Account settings" },
];

export const unauthenticatedWorkspaceNav: WorkspaceNavItem[] = [
  { id: "onboarding", label: "Access" },
];

export function workspaceNavForState(input: {
  hasSession: boolean;
  onboardingComplete: boolean;
  isPlatformAdmin?: boolean;
}): WorkspaceNavItem[] {
  if (!input.hasSession) {
    return unauthenticatedWorkspaceNav;
  }

  if (input.isPlatformAdmin) {
    return platformAdminWorkspaceNav;
  }

  const effectiveOnboardingComplete = input.onboardingComplete;

  if (!effectiveOnboardingComplete) {
    return onboardingWorkspaceNav;
  }

  return completedWorkspaceNav;
}
